import './Pill.scss';

import Pill from './Pill';

export default Pill;
